export const ACDTYPE_TEXT = 0;
export const ACDTYPE_TEXT_ONLY = 1;
export const ACDTYPE_IMAGE = 2;
export const ACDTYPE_VIDEO = 3;
export const ACDTYPE_AUDIO = 4;
export const ACDTYPE_SEPARATOR = 5;
export const ACDTYPE_IMAGE_ONLY = 6;
export const ACDTYPE_IMAGE_ARR = 7;
